<template>
  <div>
    <jala-cycle-select-ajax
        v-if="!initialValue.cycle_id"
        v-show="!value"
        :key="`${_uid}-jala-harvests-cycles`"
        name="cycle_id"
        v-model.number="cycle_id"
        :disabled="disabled"
        :initial-value="initialValue"
    ></jala-cycle-select-ajax>
    <multiselect-ajax
        v-show="cycle_id || value"
        :class="{ 'mt-3': !(value || initialValue.cycle_id) }"
        :key="`${_uid}-jala-harvests-${cycle_id}`"
        name="harvest_id"
        :placeholder="$t('Select {something}', { something: $t('jala_harvests.singular') })"
        :value="value"
        @input="(v) => onInput(v)"
        @update:selected="$emit('update:selected', $event)"
        :custom-label="customLabel || customLabelDefault"
        :required="required"
        :disabled="disabled"
        :url="`/jala/harvests`"
        :params="{ cycle_id__in: cycle_id, with: 'cycle.pond.farm', ...params }"
    >
      <template v-slot:beforeList>
        <b-button variant="link" v-b-modal="`${_uid}-jala-harvest-create-modal`">+
          {{ $t('Add new {something}', {something: $t('jala_harvests.singular')}) }}
        </b-button>
        <jala-harvest-create-modal
            :key="`${_uid}-jala-harvest-create-modal-${value}`"
            :id="`${_uid}-jala-harvest-create-modal`"
            size="lg"
            @created="onInput($event.id)"
            :initial-value="{ cycle_id }"
        ></jala-harvest-create-modal>
      </template>
      <template v-slot:option="{ option }">
        <slot name="option" v-bind="{ option }"></slot>
      </template>
    </multiselect-ajax>
  </div>
</template>

<script>
import MultiselectAjax from "./vue-multiselect-ajax";
import JalaHarvestCreateModal from '../modals/jala-harvest-create';
import JalaCycleSelectAjax from "@/components/inputs/jala-cycle-select-ajax";

export default {
  name: "jala-harvest-select-ajax",
  components: {
    JalaCycleSelectAjax,
    MultiselectAjax,
    JalaHarvestCreateModal,
  },
  props: {
    value: {
      type: Number,
      default: undefined
    },
    selected: {
      type: Object,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function () {
        return {}
      }
    },
    initialValue: {
      type: Object,
      default: function () {
        return {}
      }
    },
    customLabel: {
      type: Function,
      default: undefined
    }
  },
  data() {
    return {
      cycle_id: this.initialValue.cycle_id || null
    }
  },
  computed: {
    customLabelDefault() {
      if (this.value)
        return (v) => `${v.cycle.pond.farm.name} - ${v.cycle.pond.name} - ${this.$moment(v.cycle.started_at).format('DD MMMM YYYY')} | ${this.$moment(v.harvested_at).format('DD MMMM YYYY')} (${v.age}) | ${this.$numeral(v.weight).format('0,0.[00]')} kg (Size ${this.$numeral(v.size).format('0,0.[00]')})`;
      else return (v) => `${this.$moment(v.harvested_at).format('DD MMMM YYYY')} (${v.age}) | ${this.$numeral(v.weight).format('0,0.[00]')} kg (size ${this.$numeral(v.size).format('0,0.[00]')})`
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    }
  }
}
</script>

<style scoped>

</style>
